import React, { useEffect, useState } from "react";

import {
    Spin
} from "antd";
import { TabPanel, TabView } from "primereact/tabview";
import RequestProjectCapacity from "./RequestProjectCapacity.jsx";

const Setting = () => {
    const [apiLoading, setApiLoading] = useState(false);

    const [tabs, setTabs] = useState([]);

    useEffect(() => {
        identifyTabs();
    }, [])

    const identifyTabs = () => {
        const newTabsArray = [];
        newTabsArray.push({
            title: "Assigning Page",
            content: (
                <RequestProjectCapacity
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });

        setTabs(newTabsArray);
    };


    return (
        <div>
            <Spin spinning={apiLoading}>
                <TabView>
                    {tabs.map((tab) => {
                        return (
                            <TabPanel key={tab.title} header={tab.title}>
                                {tab.content}
                            </TabPanel>
                        );
                    })}
                </TabView>
            </Spin>
        </div>
    );
};

export default Setting;
